import { Http } from './http';

class CxInvoiceHttp extends Http {
  prefix = 'cx-invoice';

  async updateBulk(params: BulkUpdateParams): Promise<number> {
    const res = await this.put<number>('/update-bulk', params);

    return res.data;
  }
}

export const cxInvoiceHttp = new CxInvoiceHttp();

interface BulkUpdateParams {
  selectedIds: number[];
  prop: string;
  value: number | string;
}
